export default __webpack_public_path__ + "static/media/icomoon.c1658943.eot";